module.exports = __webpack_public_path__ + "static/img/SDC300应用场景-自动驾驶.81d0cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-2/SDC300应用场景-自动驾驶.png
// module id = LVOV
// module chunks = 0